import { useCallback } from 'react';
import { LinkModel } from './LinkModel';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { sanitiseKey } from '~/lib/utils/translation';
import { GetLinkDescription, RenderLinkTitle } from './GetLinkDescription';

const sanitisedLinkKey = (str: string) =>
  sanitiseKey(str.replace('_ONCLICK', '').replace('_DOWNLOAD', '').replaceAll('-', '_'));

export const useLinkTitle = () => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const title = useCallback(
    (link: LinkModel) => {
      if (link.Loading) {
        return t('LOADING_TEXT', 'Loading...');
      }
      return t(sanitisedLinkKey(link.Type) + '_LINK_LABEL', RenderLinkTitle(link));
    },
    [t]
  );
  const description = useCallback(
    (link: LinkModel) => t(sanitisedLinkKey(link.Type) + '_LINK_DESCRIPTION', GetLinkDescription(link)),
    [t]
  );

  return { title, description };
};
